/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect } from "react";
import { Nav, Tab, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import axios from "axios";
import AppConfig from "../../../../../app/config/AppConfig";
import { useHistory } from 'react-router-dom';
import swal from "sweetalert";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function UserNotificationsDropdown() {
  const [key, setKey] = useState("Penetapan");
  const bgImage = toAbsoluteUrl("/media/misc/bg-1.jpg");
  const [notifications, setNotifications] = useState([]);
  const [penetapan, setPenetapan] = useState([]);
  const [evaluasi, setEvaluasi] = useState([]);
  const [pengendalian, setPengendalian] = useState([]);
  const [peningkatan, setPeningkatan] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const handleClick = async (notif, link, e) => {
    e.preventDefault(); 
    if(notif.is_read === 0){
      try {
        const formData = new FormData();
        formData.append('data[id_notif]', notif.id_notif);
        const response = await axios.post(AppConfig.ReadNotif, formData);
        
        if (response.data.status === "sukses") {
          history.push(`/${link}/detail/${notif.id_pengaturan}`);
        } else {
          swal({
            title: "Gagal!",
            text: "Gagal mengubah status baca notifikasi!",
            icon: "error",
            button: "OK!",
          });
        }
      } catch (error) {
        console.error("Update failed:", error);
        swal({
          title: "Gagal!",
          text: "Gagal mengubah status baca notifikasi!",
          icon: "error",
          button: "OK!",
        });
      }
    }else{
      history.push(`/${link}/detail/${notif.id_pengaturan}`);
    }
  };
  
  

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.notifications.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  useEffect(() => {
    let isMounted = true;

    const fetchNotifications = async () => {
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));

      let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

      let id_sp = sessiondata.i_idunit;
      // let id_sp = "86942CDF-44F1-446E-8E9E-CB37BBBB16E6";

      if (!id_sp) return;

      setLoading(true);
      try {
        const response = await axios.get(AppConfig.GetNotification + id_sp + session);
        if (isMounted) {
          const notig = response.data.result || []; 
          const penetapanSpmi = response.data.result?.penetapan || [];
          const evaluasiSpmi = response.data.result?.evaluasi || [];
          const pengendalianSpmi = response.data.result?.pengendalian || [];
          const peningkatanSpmi = response.data.result?.peningkatan || [];
          setNotifications(notig);
          setPenetapan(penetapanSpmi);
          setPengendalian(pengendalianSpmi);
          setEvaluasi(evaluasiSpmi);
          setPeningkatan(peningkatanSpmi);
          // console.log("response.data ==", notig);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Gagal mengambil notifikasi:", error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchNotifications();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
            id="kt_quick_notifications_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")} />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown
            drop="down"
            align="end"
          >
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_notifications_toggle"
          >
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="user-notification-tooltip">
                  Notifications
                </Tooltip>
              }
            >
              <div
                className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
                id="kt_quick_notifications_toggle"
              >
                <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")}
                  />
                </span>
                <span className="pulse-ring"></span>
                <span className="pulse-ring" />
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="p-0 m-0 dropdown-menu-anim-up dropdown-menu-xl"
            style={{width: '430px'}}
          >
            <form>
              {/** Head */}
              <div
                className="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
                style={{ backgroundImage: `url(${bgImage})` }}
              >
                <h4 className="d-flex flex-center rounded-top">
                  <span className="text-white">Notifications</span>
                </h4>
                <Tab.Container defaultActiveKey={key}>
                  <Nav
                    as="ul"
                    className="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-2x nav-tabs-line-transparent-white nav-tabs-line-active-border-success mt-1 px-4 font-size-sm"
                    onSelect={(_key) => setKey(_key)}
                    
                  >
                    <Nav.Item className="nav-item" as="li">
                      {/* <Nav.Link
                        eventKey="Penetepan"
                        className={`nav-link show ${
                          key === "Penetapan" ? "active" : ""
                        }`}
                      >
                        Penetapan
                      </Nav.Link> */}
                      <Nav.Link
                        eventKey="Penetapan"
                        className={`nav-link show ${key === "Penetapan" ? "active" : ""}`}
                      >
                        Penetapan
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link
                        eventKey="Evaluasi"
                        className={`nav-link show ${
                          key === "Evaluasi" ? "active" : ""
                        }`}
                      >
                        Evaluasi
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link
                        eventKey="Pengendalian"
                        className={`nav-link show ${
                          key === "Pengendalian" ? "active" : ""
                        }`}
                      >
                        Pengendalian
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link
                        eventKey="Peningkatan"
                        className={`nav-link show ${
                          key === "Peningkatan" ? "active" : ""
                        }`}
                      >
                        Peningkatan
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content className="tab-content">
                    <Tab.Pane eventKey="Penetapan" className="p-4">
                      <PerfectScrollbar
                        options={perfectScrollbarOptions}
                        className="scroll pr-7 mr-n7"
                        style={{ maxHeight: "300px", position: "relative" }}
                      >
                        {Array.isArray(penetapan) && penetapan.length > 0 ? (
                        penetapan.map((notif, index) => (
                          <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick(notif, "ajuan-pengaturan", e);
                              }}
                              className="navi-item"
                              key={index}
                            >
                            <div className="navi-link d-flex">
                              {/* <div className="navi-icon mr-2">
                                <i className="flaticon-list-2 text-primary"></i>
                              </div> */}
                              <div className="navi-icon mr-2">
                                {notif.statusajuan === 1 ? (
                                  <i className="flaticon2-delete text-danger"></i> 
                                ) : notif.statusajuan === 3 ? (
                                  <i className="flaticon2-checkmark text-success"></i> 
                                ) : (
                                  <i className="flaticon-list-2 text-primary"></i> 
                                )}
                              </div>
                              <div className="navi-text">
                                <div className="font-weight-bold">{notif.jenis_notif}</div>
                                <div className="text-muted d-flex align-items-center">
                                  Ada pengaturan penetapan yang telah di verifikasi, klik untuk melihatnya
                                </div>
                                <div className="text-muted d-flex align-items-center">
                                  <i className="fa fa-eye" aria-hidden="true"></i>&nbsp;
                                  <span className={`ms-1 ${notif.is_read === 0 ? 'text-primary' : ''}`}>
                                    {notif.is_read === 0 ? 'Notifikasi baru' : 'Terbaca'}
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <i className="flaticon-time-1 text-primary"></i>
                                  <span className="ml-2">
                                    {(() => {
                                      const date = new Date(notif.tgl_create);
                                      const day = String(date.getDate()).padStart(2, "0");
                                      const month = String(date.getMonth() + 1).padStart(2, "0");
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                      ) : (
                        <div className="text-center py-4 text-muted">
                          Tidak ada notifikasi
                        </div>
                      )}
                      </PerfectScrollbar>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Evaluasi" className="p-4">
                      <PerfectScrollbar
                        options={perfectScrollbarOptions}
                        className="scroll pr-7 mr-n7"
                        style={{ maxHeight: "300px", position: "relative" }}
                      >
                        {Array.isArray(evaluasi) && evaluasi.length > 0 ? (
                        evaluasi.map((notif, index) => (
                          <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick(notif, "ajuan-evaluasi", e);
                              }}
                              className="navi-item"
                              key={index}
                            >
                            <div className="navi-link d-flex">
                              {/* <div className="navi-icon mr-2">
                                <i className="flaticon-list-2 text-primary"></i>
                              </div> */}
                              <div className="navi-icon mr-2">
                                {notif.statusajuan === 1 ? (
                                  <i className="flaticon2-delete text-danger"></i> 
                                ) : notif.statusajuan === 3 ? (
                                  <i className="flaticon2-checkmark text-success"></i> 
                                ) : (
                                  <i className="flaticon-list-2 text-primary"></i> 
                                )}
                              </div>
                              <div className="navi-text">
                                <div className="font-weight-bold">{notif.jenis_notif}</div>
                                <div className="text-muted d-flex align-items-center">
                                  Ada pengaturan Evaluasi yang telah di verifikasi, klik untuk melihatnya
                                </div>
                                <div className="text-muted d-flex align-items-center">
                                  <i className="fa fa-eye" aria-hidden="true"></i>&nbsp;
                                  <span className={`ms-1 ${notif.is_read === 0 ? 'text-primary' : ''}`}>
                                    {notif.is_read === 0 ? 'Notifikasi baru' : 'Terbaca'}
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <i className="flaticon-time-1 text-primary"></i>
                                  <i className=" ? 'bi bi-dot' : 'bi bi-dot text-muted'"></i>
                                  <span className="ml-2">
                                    {(() => {
                                      const date = new Date(notif.tgl_create);
                                      const day = String(date.getDate()).padStart(2, "0");
                                      const month = String(date.getMonth() + 1).padStart(2, "0");
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                      ) : (
                        <div className="text-center py-4 text-muted">
                          Tidak ada notifikasi
                        </div>
                      )}
                      </PerfectScrollbar>
                    </Tab.Pane>


                    <Tab.Pane eventKey="Pengendalian" className="p-4">
                      <PerfectScrollbar
                        options={perfectScrollbarOptions}
                        className="scroll pr-7 mr-n7"
                        style={{ maxHeight: "300px", position: "relative" }}
                      >
                        {Array.isArray(pengendalian) && pengendalian.length > 0 ? (
                        pengendalian.map((notif, index) => (
                          <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick(notif, "ajuan-pengendalian", e);
                              }}
                              className="navi-item"
                              key={index}
                            >
                            <div className="navi-link d-flex">
                              {/* <div className="navi-icon mr-2">
                                <i className="flaticon-list-2 text-primary"></i>
                              </div> */}
                              <div className="navi-icon mr-2">
                                {notif.statusajuan === 1 ? (
                                  <i className="flaticon2-delete text-danger"></i> 
                                ) : notif.statusajuan === 3 ? (
                                  <i className="flaticon2-checkmark text-success"></i> 
                                ) : (
                                  <i className="flaticon-list-2 text-primary"></i> 
                                )}
                              </div>
                              <div className="navi-text">
                                <div className="font-weight-bold">{notif.jenis_notif}</div>
                                <div className="text-muted d-flex align-items-center">
                                  Ada pengaturan pengendalian yang telah di verifikasi, klik untuk melihatnya
                                </div>
                                <div className="text-muted d-flex align-items-center">
                                  <i className="fa fa-eye" aria-hidden="true"></i>&nbsp;
                                  <span className={`ms-1 ${notif.is_read === 0 ? 'text-primary' : ''}`}>
                                    {notif.is_read === 0 ? 'Notifikasi baru' : 'Terbaca'}
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <i className="flaticon-time-1 text-primary"></i>
                                  <span className="ml-2">
                                    {(() => {
                                      const date = new Date(notif.tgl_create);
                                      const day = String(date.getDate()).padStart(2, "0");
                                      const month = String(date.getMonth() + 1).padStart(2, "0");
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                      ) : (
                        <div className="text-center py-4 text-muted">
                          Tidak ada notifikasi
                        </div>
                      )}
                      </PerfectScrollbar>
                    </Tab.Pane>
                    <Tab.Pane eventKey="Peningkatan" className="p-4">
                      <PerfectScrollbar
                        options={perfectScrollbarOptions}
                        className="scroll pr-7 mr-n7"
                        style={{ maxHeight: "300px", position: "relative" }}
                      >
                        {Array.isArray(peningkatan) && peningkatan.length > 0 ? (
                        peningkatan.map((notif, index) => (
                          <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick(notif, "ajuan-peningkatan", e);
                              }}
                              className="navi-item"
                              key={index}
                            >
                            <div className="navi-link d-flex">
                              {/* <div className="navi-icon mr-2">
                                <i className="flaticon-list-2 text-primary"></i>
                              </div> */}
                              <div className="navi-icon mr-2">
                                {notif.statusajuan === 1 ? (
                                  <i className="flaticon2-delete text-danger"></i> 
                                ) : notif.statusajuan === 3 ? (
                                  <i className="flaticon2-checkmark text-success"></i> 
                                ) : (
                                  <i className="flaticon-list-2 text-primary"></i> 
                                )}
                              </div>
                              <div className="navi-text">
                                <div className="font-weight-bold">{notif.jenis_notif}</div>
                                <div className="text-muted d-flex align-items-center">
                                  Ada pengaturan {notif.jenis_notif} yang telah di verifikasi, klik untuk melihatnya
                                </div>
                                <div className="text-muted d-flex align-items-center">
                                 <i className="fa fa-eye" aria-hidden="true"></i>&nbsp;
                                  <span className={`ms-1 ${notif.is_read === 0 ? 'text-primary' : ''}`}>
                                    {notif.is_read === 0 ? 'Notifikasi baru' : 'Terbaca'}
                                  </span>
                                  &nbsp;&nbsp;&nbsp;
                                  <i className="flaticon-time-1 text-primary"></i>
                                  <span className="ml-2">
                                    {(() => {
                                      const date = new Date(notif.tgl_create);
                                      const day = String(date.getDate()).padStart(2, "0");
                                      const month = String(date.getMonth() + 1).padStart(2, "0");
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        ))
                      ) : (
                        <div className="text-center py-4 text-muted">
                          Tidak ada notifikasi
                        </div>
                      )}
                      </PerfectScrollbar>
                    </Tab.Pane>

                  </Tab.Content>
                </Tab.Container>
              </div>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
